const MIN_ID = 10000000;
const MAX_ID = 99999999;

export function randomUserId(): string {
  return (Math.floor(Math.random() * MAX_ID) + MIN_ID).toString();
}
